import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import wocRatings from "../../../../src/data/articles/cube-prospective-wilds-of-eldraine-commander/woc-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  wocRatings,
  ProspectiveIntro,
  React
};